import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// tslint:disable:restrict-plus-operands
import Fuse from 'fuse.js';
import React, { useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Button } from '../Button';
import { Input } from '../Input';
import { Link } from '../Link';
import { ListTable } from '../ListTable';
import { LoadingSpinner } from '../LoadingSpinner';
import { Modal } from '../Modal';
import { Text } from '../Text';
import styles from './styles.scss';
export var ENTITY_SEARCH_FIELDS = ['id', 'name', 'state', 'country', 'subdomain', 'display_name', 'entity_type'];
export var EntitySwitcherNoResults = function EntitySwitcherNoResults(_ref) {
  var showCreateEntity = _ref.showCreateEntity,
      onCreateEntity = _ref.onCreateEntity;
  return React.createElement("div", {
    className: styles.noResultsWrapper
  }, React.createElement(Text, {
    size: "small",
    font: "bold"
  }, "No entity was found with this filter."), showCreateEntity ? React.createElement(React.Fragment, null, React.createElement(Text, {
    size: "small"
  }, "Try another search or..."), React.createElement(Button, {
    variant: "primary",
    onClick: onCreateEntity
  }, "Create Entity")) : null);
};
export var EntitySwitcherItem = function EntitySwitcherItem(_ref2) {
  var name = _ref2.name,
      state = _ref2.state,
      country = _ref2.country,
      type = _ref2.type,
      id = _ref2.id,
      link = _ref2.link;
  return React.createElement(ListTable.Row, {
    href: link,
    ariaLabel: "Navigate to ".concat(name, " entity")
  }, React.createElement(ListTable.Cell, null, React.createElement("b", null, name), ", ", state, ", ", country), React.createElement(ListTable.Cell, null, type), React.createElement(ListTable.Cell, null, id));
};
var GUTTER_SIZE = 4;
var ROW_HEIGHT = 35;
export var EntityRowRenderer = function EntityRowRenderer(_ref3) {
  var index = _ref3.index,
      style = _ref3.style,
      data = _ref3.data;
  var entity = data.entities[index];
  return React.createElement("div", {
    style: _objectSpread(_objectSpread({}, style), {
      top: style.top + GUTTER_SIZE,
      height: style.height + GUTTER_SIZE
    })
  }, React.createElement(EntitySwitcherItem, {
    name: entity.name,
    state: entity.state,
    country: entity.country,
    type: entity.entity_type,
    id: entity.subdomain,
    link: "".concat(data.currentAppPathname, "/").concat(entity.subdomain)
  }));
};
export var EntitySwitcher = function EntitySwitcher(_ref4) {
  var _ref4$canCreateEntity = _ref4.canCreateEntity,
      canCreateEntity = _ref4$canCreateEntity === void 0 ? false : _ref4$canCreateEntity,
      createEntityLink = _ref4.createEntityLink,
      entities = _ref4.entities,
      currentAppPathname = _ref4.currentAppPathname,
      onClose = _ref4.onClose,
      onCreateEntity = _ref4.onCreateEntity;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var filteredEntities = [];
  var fuse = new Fuse(entities, {
    keys: ENTITY_SEARCH_FIELDS,
    threshold: 0.2
  });

  if (searchText.length) {
    filteredEntities = fuse.search(searchText);
  } else {
    filteredEntities = entities;
  }

  var isLoading = !filteredEntities.length && !searchText;
  var noResults = !filteredEntities.length && searchText;
  return React.createElement(Modal.Work, {
    onClose: onClose,
    title: "Switch entity",
    description: React.createElement(React.Fragment, null, canCreateEntity && createEntityLink ? React.createElement(React.Fragment, null, "Select an existing entity or", ' ', React.createElement(Link.Standard, {
      href: createEntityLink,
      onClick: onCreateEntity,
      text: "create a new entity"
    }), ".") : null)
  }, React.createElement("div", {
    className: styles.inputWrapper
  }, React.createElement(Input.Text, {
    placeholder: "Filter entities",
    onChange: setSearchText
  })), React.createElement("div", {
    className: isLoading ? styles.loadingSpinnerWrapper : styles.contentWrapper
  }, isLoading && React.createElement(LoadingSpinner, {
    variant: "page",
    message: "Loading Entities"
  }), noResults && React.createElement(EntitySwitcherNoResults, {
    showCreateEntity: canCreateEntity,
    onCreateEntity: onCreateEntity
  }), !noResults && !isLoading && React.createElement(ListTable, {
    variant: "condensed"
  }, !!filteredEntities.length && React.createElement(ListTable.Header, null, React.createElement(ListTable.HeaderCell, null, "Entity"), React.createElement(ListTable.HeaderCell, null, "Type"), React.createElement(ListTable.HeaderCell, null, "ID")), React.createElement(List, {
    height: 460,
    itemCount: filteredEntities.length,
    itemData: {
      entities: filteredEntities,
      currentAppPathname: currentAppPathname
    },
    itemSize: ROW_HEIGHT + GUTTER_SIZE,
    width: "100%"
  }, EntityRowRenderer))));
};